import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { routes } from "../../constants/routes";
import "./style.less";

import IdleSessionTimer from "../../components/common/idleTimer";
import ErrorPage from "../ErrorPage";
import commonLabels from "../../constants/messageConstants";
import Dashboard from "../../components/Dashboard/DashBoard";
import Reports from "../../components/Reports/Reports";
import Configurations from "../../components/configuration/configurations";
import AboutUs from "../aboutUs";
import { IsTenant, IsSectionVisible, IsTenantAdmin } from "../../utils/helper";
import TenantLogin from "../tenantLogin/tenantLogin";
import { SECTIONS } from "../../constants/appConstants";
import Tenants from "../../components/Tenant/tenants";
import Requests from "../../components/Request/requests";
import Contacts from "../../components/Tenant/contact/contacts";
import TenantView from "../../components/Tenant/tenantView/tenantView";
import massCommunication from "../../components/MassCommunication/massCommunication";
import HealthAndSafety from "../../components/HealthAndSafety";
import ReportTable from "../../components/Reporting/ReportTable";
import SecurityIncident from "../../components/SecurityIncident/securityIncident";
import GrantAccessRequest from "../../components/Request/GrantAccessRequest/GrantAccessRequest";
import ApiKeyManagement from "../../components/Tenant/apiKeyManagement";
import WelComePage from "../../components/Welcome/WelcomePage";

const renderMergedProps = (component, ...rest) => {
	const finalProps = Object.assign({}, ...rest);
	return React.createElement(component, finalProps);
};

/** Route props */
const PropsRoute = ({ component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={routeProps => {
				return renderMergedProps(component, routeProps, rest);
			}}
		/>
	);
};
const layout = "";
export default function WorkSpace({ defaultPage, asOfDate, userData }) {
	localStorage.setItem("IsInEditMode", 0);
	return (
		<>
			<Switch>
				<Redirect exact from={"/"} to={`/${defaultPage}`} />
				<Route
					exact
					path={"/redirect"}
					render={() => {
						window.location.href = window.location.origin + "/redirect.html";
					}}
				/>
				{";\r"}
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.WELCOME)
								? routes.welcome
								: routes.unAuthorizedAccess
						}`
					}
					component={
						IsSectionVisible(SECTIONS.WELCOME) ? WelComePage : ErrorPage
					}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.DASHBOARD)
								? routes.adminDashboard
								: routes.unAuthorizedAccess
						}`
					}
					component={
						IsSectionVisible(SECTIONS.DASHBOARD) ? Dashboard : ErrorPage
					}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.TENANT)
								? routes.tenants
								: routes.unAuthorizedAccess
						}`
					}
					component={IsTenant() ? TenantView : Tenants}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.TENANT)
								? routes.tenantContacts
								: routes.unAuthorizedAccess
						}`
					}
					component={Contacts}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.REQUEST)
								? routes.requests
								: routes.unAuthorizedAccess
						}`
					}
					component={Requests}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.HSE_INCIDENT_MENU)
								? routes.healthAndSafety
								: routes.unAuthorizedAccess
						}`
					}
					component={HealthAndSafety}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.COMMUNICATION)
								? routes.communication
								: routes.unAuthorizedAccess
						}`
					}
					component={massCommunication}
					asOfDate={asOfDate}
					userData={userData}
				/>
				{"; ;\r"}
				<PropsRoute
					path={layout + `/${routes.kpi}`}
					component={Reports}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.CONFIGURATION)
								? routes.configurations
								: routes.unAuthorizedAccess
						}`
					}
					component={
						IsSectionVisible(SECTIONS.CONFIGURATION)
							? Configurations
							: ErrorPage
					}
					/*  path={layout+`/${ routes.configurations }`}
          component={Configurations } */
					userData={userData}
				/>
				<PropsRoute
					path={layout + `/${routes.error}`}
					component={ErrorPage}
					details={commonLabels.serverError}
					userData={userData}
				/>
				<PropsRoute
					path={layout + `/${routes.unAuthorizedAccess}`}
					component={ErrorPage}
					details={commonLabels.unAuthorizedAccess}
					userData={userData}
				/>
				<PropsRoute
					path={layout + `/${routes.notfound}`}
					component={ErrorPage}
					details={commonLabels.pageNotFound}
				/>
				<PropsRoute
					path={layout + `/${routes.tenantLogin}`}
					component={TenantLogin}
					details={commonLabels.tenantLogin}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS)
								? routes.newGrantAccess
								: routes.unAuthorized
						}`
					}
					component={
						IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS)
							? GrantAccessRequest
							: ErrorPage
					}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<Route
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.ABOUT_US)
								? routes.aboutUs
								: routes.unAuthorizedAccess
						}`
					}
					component={IsSectionVisible(SECTIONS.ABOUT_US) ? AboutUs : ErrorPage}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(
								SECTIONS.REPORTING,
								SECTIONS.REPORTING,
								SECTIONS.ADD_EDIT
							)
								? routes.reporting
								: routes.unAuthorizedAccess
						}`
					}
					userData={userData}
					//component={ ReportTable }
					component={
						IsSectionVisible(
							SECTIONS.REPORTING,
							SECTIONS.REPORTING,
							SECTIONS.ADD_EDIT
						)
							? ReportTable
							: ErrorPage
					}
				/>

				<Route
					path={
						layout +
						`/${
							IsTenantAdmin() && IsSectionVisible(SECTIONS.TENANT, SECTIONS.API_KEY_MANAGEMENT)
								? routes.apiKeyManagement
								: routes.unAuthorizedAccess
						}`
					}
					component={ApiKeyManagement}
				/>
				<PropsRoute
					path={
						layout +
						`/${
							IsSectionVisible(SECTIONS.SECURITY_INCIDENT)
								? routes.securityIncident
								: routes.unAuthorizedAccess
						}`
					}
					component={
						IsSectionVisible(SECTIONS.SECURITY_INCIDENT)
							? SecurityIncident
							: ErrorPage
					}
					asOfDate={asOfDate}
					userData={userData}
				/>
				<Route
					component={() => <ErrorPage details={commonLabels.pageNotFound} />}
				/>
			</Switch>
			<IdleSessionTimer />
		</>
	);
}
